import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { CreditCard, DollarSign } from 'lucide-react';
import { paymentAPI } from '@/lib/api';

const Checkout = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const packages = [
    { id: 'credits_50', name: '50 Credits', price: 10.0, credits: 50 },
    { id: 'credits_100', name: '100 Credits', price: 45.0, credits: 100 },
    { id: 'credits_300', name: '300 Credits', price: 85.0, credits: 300 },
  ];

  const handleCheckout = async (packageId) => {
    setLoading(true);
    setSelectedPackage(packageId);
    try {
      const origin_url = window.location.origin;
      const response = await paymentAPI.createCheckout(packageId, origin_url);
      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to create checkout');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface py-8">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <div className="mb-8 text-center">
          <h1 data-testid="checkout-heading" className="text-3xl font-chivo font-bold text-slate-900 mb-2">
            Add Credits
          </h1>
          <p className="text-slate-600">Choose a credit package to continue</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {packages.map((pkg) => (
            <Card
              key={pkg.id}
              data-testid={`package-card-${pkg.id}`}
              className="p-8 text-center hover:shadow-lg transition-all duration-200"
            >
              <DollarSign className="w-12 h-12 text-accent mx-auto mb-4" />
              <h3 className="text-2xl font-chivo font-bold text-slate-900 mb-2">{pkg.name}</h3>
              <p className="text-4xl font-chivo font-black text-accent mb-4">
                A${pkg.price}
              </p>
              <p className="text-sm text-slate-600 mb-6">{pkg.credits} credits</p>
              <Button
                data-testid={`buy-btn-${pkg.id}`}
                className="w-full"
                onClick={() => handleCheckout(pkg.id)}
                disabled={loading && selectedPackage === pkg.id}
              >
                <CreditCard className="w-4 h-4 mr-2" />
                {loading && selectedPackage === pkg.id ? 'Processing...' : 'Buy Now'}
              </Button>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button
            data-testid="back-btn"
            variant="ghost"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
